import { useCallback } from 'react';

import ChatIcon from '@mui/icons-material/AssistantRounded';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';

function ChatAction() {
  const handleClick = useCallback(() => {
    // TODO: Open NiCE Chat with enterprise context included. See shopping-ui as an example. [SAL-5652]
    console.error('ChatAction clicked');
  }, []);

  return (
    <Button
      clickstreamProps={{
        elementName: 'help_section_chat_action'
      }}
      fullWidth
      icon={<ChatIcon />}
      onClick={handleClick}
      variant="text"
      sx={{
        justifyContent: 'start'
      }}
    >
      <FormattedMessage id="dashboard.helpSection.actions.chatAction.label" />
    </Button>
  );
}

export default ChatAction;
